import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";

const BrandJoinNudgePage = withCompass(
  () => import("../../pages/BrandJoinNudgePage")
);

export function KendraConnRoutes() {
  return (
    <Switch>
      <Route path="/kc/brand-join-nudge" component={BrandJoinNudgePage} />
    </Switch>
  );
}

export const slug = "kc";
